import { createContext, ReactNode, useContext, useMemo } from 'react';

import { usePreAuthOffer } from '../features/offers/hooks/usePreAuthOffer';

interface PreAuthOfferContextProps {
  children: ReactNode;
  productVariantId?: string;
  productId?: string;
}

const PreAuthOfferContext = createContext<ReturnType<typeof usePreAuthOffer>>({
  handleMakeOffer: async () => Promise.resolve(false),
  loading: false,
  data: undefined,
  error: undefined,
  addresses: undefined,
  paymentMethods: undefined,
  selectedAddressId: undefined,
  setSelectedAddressId: () => {},
  selectedPaymentMethodId: undefined,
  setSelectedPaymentMethodId: () => {},
  isBillingSameAsShipping: false,
  setIsBillingSameAsShipping: () => {},
  billingAddress: null,
  setBillingAddress: () => {},
  setupSecret: undefined,
  handleSetupPreAuthFlow: async () => {},
  isNewPaymentMethod: false,
  setIsNewPaymentMethod: () => {},
  handleConfirmOffer: async () => Promise.resolve(false),
  handlePaymentMethodUpdate: async () => {},
  handleAddressUpdate: async () => {},
  setError: () => {},
});

export const PreAuthOfferProvider = ({
  children,
  productId,
  productVariantId,
}: PreAuthOfferContextProps) => {
  const state = usePreAuthOffer(productVariantId, productId);

  const context = useMemo(() => state, [state]);

  return (
    <PreAuthOfferContext.Provider value={context}>
      {children}
    </PreAuthOfferContext.Provider>
  );
};

export const usePreAuthOfferCtx = () => useContext(PreAuthOfferContext);
